import styled from '@emotion/styled'
import { Card as NovaCard, CardProps as NovaCardProps } from '@fme-nova/components'
import { CardProps as MuiCardProps, default as MuiCard } from '@mui/material/Card'

import { createComponentWrapperWithRef } from '../../theme'

export const Card = createComponentWrapperWithRef<MuiCardProps | NovaCardProps>(
  {
    mui: MuiCard,
    nova: styled(NovaCard)`
      background-color: white;
    `,
  },
  'Card',
)
